"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Generated using scripts/write-decode-map.ts
// prettier-ignore

exports.default = new Uint16Array([1024, 97, 103, 108, 113, 9, 23, 27, 31, 1086, 15, 0, 0, 19, 112, 59, 32768, 38, 111, 115, 59, 32768, 39, 116, 59, 32768, 62, 116, 59, 32768, 60, 117, 111, 116, 59, 32768, 34]);